/**
 * Session service – penyimpanan token pairing yang kompatibel webOS + browser.
 */

const TOKEN_KEY = 'webos:pairing:token:v1';

export function getToken() {
  try {
    return String(localStorage.getItem(TOKEN_KEY) || '');
  } catch {
    return '';
  }
}

export function setToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, String(token || ''));
  } catch {}
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}
